import React from "react"
import types from "prop-types"
import { isEmpty } from "lodash-es"
import { useSelector } from "react-redux"
import { conversations as conversationsSelector } from "reduxSlices/formSubmissionConversationsSlice"
import ConversationListItem from "./ConversationListItem"

const ConversationList = ({ className = "" }) => {
  const conversations = useSelector(conversationsSelector)

  if (isEmpty(conversations)) {
    return (
      <div className={className}>
        No conversations with the submitter have been opened.
      </div>
    )
  }

  return (
    <div className={className}>
      {
        conversations.map((conversation) => (
          <ConversationListItem
            key={`conversation-${conversation.id}`}
            conversation={conversation}
          />
        ))
      }
    </div>
  )
}

ConversationList.propTypes = {
  className: types.string,
}

export default ConversationList
